module.exports = __webpack_public_path__ + "static/media/chrome_icon.6a341ef5.png";